import { UseFormReturnType, useForm } from '@mantine/form';
import {
  ChatAttachmentConfigurationFormValues,
  SmartAssistant,
  SmartAssistantType
} from 'shared/interfaces/SmartAssistant';

type AdvancedFormKeys = 'chatAttachmentConfigurationForm';

interface AdvancedFormsReturn {
  chatAttachmentConfigurationForm?: UseFormReturnType<ChatAttachmentConfigurationFormValues>;
  formToSmartAssistantField: Record<AdvancedFormKeys, keyof SmartAssistant>;
}

export function useAdvancedForms(type: SmartAssistantType, smartAssistant?: SmartAssistant): AdvancedFormsReturn {
  const formToSmartAssistantField: Record<AdvancedFormKeys, keyof SmartAssistant> = {
    chatAttachmentConfigurationForm: 'chatAttachmentConfiguration'
  };

  const chatAttachmentConfigurationForm = useForm({
    initialValues: {
      isImageEnabled: smartAssistant?.chatAttachmentConfiguration?.isImageEnabled ?? false,
      isAudioEnabled: smartAssistant?.chatAttachmentConfiguration?.isAudioEnabled ?? false
    },
    validate: {}
  });

  switch (type) {
    case SmartAssistantType.DISCORD:
    case SmartAssistantType.PHONE:
      return { formToSmartAssistantField };
    case SmartAssistantType.BASIC:
    case SmartAssistantType.FACEBOOK:
    case SmartAssistantType.INSTAGRAM:
    case SmartAssistantType.WHATSAPP:
    case SmartAssistantType.WEBSITE:
    case SmartAssistantType.SHOPIFY:
    case SmartAssistantType.BIGCOMMERCE:
    case SmartAssistantType.WIX:
    case SmartAssistantType.WOOCOMMERCE:
    case SmartAssistantType.SQUARESPACE:
      return {
        chatAttachmentConfigurationForm,
        formToSmartAssistantField
      };
    default:
      return { formToSmartAssistantField };
  }
}
